'use client';
import { useGetRetentionBanner } from '../../hooks/useGetRetentionBanner';
import { AbstractBanner } from '../AbstractBanner';
import { BannerContainer } from './styles';

export const HeaderBanner = () => {
	const data = useGetRetentionBanner('under-header');

	if (data.status !== 'ready') {
		return null;
	}

	return (
		<BannerContainer>
			<AbstractBanner banners={data.banners} />
		</BannerContainer>
	);
};
